export default __webpack_public_path__ + "static/media/01.faf5411d.png";